import React, { useState } from "react";
import ActionButtonBar from "./TimeStampClock/ActionButtonBar";
import { ResponseCalculatedWorkingDays } from "../../API/response/worktimeclock";
import { clockTimingInterface } from "../../API/request/clockTimingInterface";
import Clock from "./TimeStampClock/Clock";
import StatusBar from "./TimeStampClock/StatusBar";
import {Card} from "react-bootstrap";
import {UniCol, UniSpinner} from "../../../../@WUM/core/Elements";

interface WorkTimeTrackingProps {}

const WorkTimeTracking = (props: WorkTimeTrackingProps) => {
    const today = new Date().toISOString().split("T")[0];
    const [refreshCounter, setRefreshCounter] = useState(0);

    const result = ResponseCalculatedWorkingDays(today, refreshCounter);
    const currentState = result !== true && result !== undefined ? result : null;

    const [workData, setWorkData] = useState<clockTimingInterface | null>(null);

    const handleStateUpdate = (data: clockTimingInterface) => {
        setWorkData(data);
    };

    const triggerRefresh = () => {
        setRefreshCounter((prev) => prev + 1);
    };

    if (currentState !== null) {
        return (
            <>
                <UniCol md={4} xs={6}>
                    <Card className="w-100 card" style={{maxWidth: "580px"}}>
                        <Card.Header>
                            <StatusBar/>
                        </Card.Header>
                        <Card.Body>
                            <div className="clock-timing border rounded shadow-sm p-4">

                                <Clock data={currentState}/>

                                <ActionButtonBar
                                    currentState={currentState}
                                    today={today}
                                    onStartWorkSuccess={handleStateUpdate}
                                    onRefresh={triggerRefresh}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </UniCol>
            </>
        );
    } else {
        return <><UniSpinner /></>;
    }
};

export default WorkTimeTracking;
